import { render, staticRenderFns } from "./ObservationThanks.vue?vue&type=template&id=ca3a9ca2&scoped=true"
import script from "./ObservationThanks.vue?vue&type=script&lang=js"
export * from "./ObservationThanks.vue?vue&type=script&lang=js"
import style0 from "./ObservationThanks.vue?vue&type=style&index=0&id=ca3a9ca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3a9ca2",
  null
  
)

export default component.exports